"use strict";

const angular = require("angular");

angular
    .module("Agnes")
    .factory("$user", [
        "$oidc",
        function (oidc) {

            var user = {
                get isAuthenticated() {
                    return typeof oidc.current !== "undefined" && oidc.current !== null;
                },
                get name() {
                    return this.isAuthenticated ? oidc.current.user_info.name : null;
                },
                get loginName() {
                    return this.isAuthenticated ? oidc.current.user_info.user_login : null;
                },
                get isOnBehalfOfDealers() {
                    return this.isAuthenticated && oidc.current.user_info.role.includes("onBehalfOfDealers");
                },
                get isTechnicalSupportReader() {
                    return this.isAuthenticated && oidc.current.user_info.role.includes("technicalSupport_ReadCases");
                },
                get isTechnicalSupportEditor() {
                    return this.isAuthenticated && oidc.current.user_info.role.includes("technicalSupport_Editor");
                },
                get isTechnicalSupportUser() {
                    return this.isTechnicalSupportReader || this.isTechnicalSupportEditor;
                },
                get isMenuPricingReader() {
                    return this.isAuthenticated && oidc.current.user_info.role.includes("menuPricing_Reader");
                },
                get isMenuPricingEditor() {
                    return this.isAuthenticated && oidc.current.user_info.role.includes("menuPricing_Editor");
                },
                get isMenuPricingUser() {
                    return this.isMenuPricingEditor || this.isMenuPricingReader;
                },
                get isExtendedWarrantyReader() {
                    return this.isAuthenticated && oidc.current.user_info.role.includes("extendedWarranty_Reader");
                },
                get isExtendedWarrantyEditor() {
                    return this.isAuthenticated && oidc.current.user_info.role.includes("extendedWarranty_Editor");
                },
                get isReportReader() {
                    return this.isAuthenticated && oidc.current.user_info.role.includes("reportReader");
                },
                get isExtendedWarrantyUser() {
                    return this.isExtendedWarrantyEditor || this.isExtendedWarrantyReader;
                },
                get repairerId() {
                    return this.isAuthenticated ? oidc.current.user_info.dealer_id : null;
                }
            };

            return user;
        }
    ]);